import React from 'react'
import { Route, Switch } from 'react-router'
import { PromotionCodes } from './pages/PromotionCodes'

export const PromotionCodeRouter = () => (
  <Switch>
    <Route exact path='/promotion-codes' component={PromotionCodes} />
  </Switch>
)
